<template>
  <div class="rule-setting">
    <el-form ref="form" :model="model" :rules="rules" label-width="140px">
      <el-row class="class-title layout">
        <i></i>
        基础设置
      </el-row>
      <el-form-item prop="enableCollectionRule">
        <div slot="label">
          领取频率规则
          <span class="el-icon-question" title="设置用户每天从公海领取的最大数量"></span>
        </div>
        <el-radio-group v-model="model.enableCollectionRule">
          <el-radio :label="0">不限制</el-radio>
          <el-radio :label="1">限制</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="collectionCount" v-if="model.enableCollectionRule">
        每天最多领取
        <el-input-number class="count" v-model="model.collectionCount" :min="0" :step-strictly="true"
                         :controls="false"></el-input-number>
        个公海客户
      </el-form-item>
      <el-form-item prop="enableRemindRule">
        <div slot="label">
          提醒规则
          <span class="el-icon-question" title="设置提前提醒用户待跟进记录信息规则"></span>
        </div>
        <el-radio-group v-model="model.enableRemindRule">
          <el-radio :label="0">不提醒</el-radio>
          <el-radio :label="1">提醒</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="remindDay" v-if="model.enableRemindRule">
        提前
        <el-input-number class="count" v-model="model.remindDay" :min="0" :step-strictly="true"
                         :controls="false"></el-input-number>
        天提醒负责人
      </el-form-item>
      <el-form-item prop="enableTakeBackRule">
        <div slot="label">
          收回规则
          <span class="el-icon-question" title="设置回收用户到公海的规则"></span>
        </div>
        <el-radio-group v-model="model.enableTakeBackRule" @change="changeBackRule">
          <el-radio :label="1">自动回收</el-radio>
          <el-radio :label="0">不自动回收</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="followupDay" v-if="model.enableTakeBackRule">
        <el-checkbox v-model="model.followupRule">
          超过
          <el-input-number class="count" :min="0" v-model="model.followupDay" :step-strictly="true"
                           :controls="false"></el-input-number>
          天“无新建跟进记录”的客户，由系统定时退回公海客户池
        </el-checkbox>
      </el-form-item>
      <el-form-item prop="noDealDay" v-if="model.enableTakeBackRule">
        <el-checkbox v-model="model.noDealRule">
          超过
          <el-input-number class="count" :min="0" v-model="model.noDealDay" :step-strictly="true"
                           :controls="false"></el-input-number>
          天“未成交”的客户，由系统定时退回公海客户池
        </el-checkbox>
      </el-form-item>
      <el-form-item prop="shieldDay" v-if="model.enableTakeBackRule">
        <el-checkbox v-model="model.shieldRule">
          回收到公海的客户资源，对原负责人屏蔽
          <el-input-number class="count" :min="0" v-model="model.shieldDay" :step-strictly="true"
                           :controls="false"></el-input-number>
          日
        </el-checkbox>
      </el-form-item>
      <el-form-item prop="conllectionDistance">
        <span slot="label">
          允许领取距离
          <span class="el-icon-question" title="设置app应用公海模块领取客户的限制距离"></span>
        </span>
        <el-input class="count" style="width: 200px" v-model="model.conllectionDistance" maxlength="10"
                  placeholder="可领取多少米范围的客户"/> 米
      </el-form-item>
      <el-row class="class-title layout">
        <i></i>
        报备设置
      </el-row>
      <el-form-item prop="reportValidityDay" label="报备有效期">
        <el-input-number class="count" style="width: 200px" v-model="model.reportValidityDay"
                         placeholder="多少天" :min="0" :step-strictly="true" :controls="false"/>
        天
      </el-form-item>
      <el-form-item prop="serveProtectDay" label="服务保护期">
        <el-input-number class="count" style="width: 200px" v-model="model.serveProtectDay"
                         placeholder="多少天" :min="0" :step-strictly="true" :controls="false"/>
        天
      </el-form-item>
      <el-form-item prop="reportRemindDay" label="报备到期提醒">
        提前
        <el-input-number class="count" style="width: 200px" v-model="model.reportRemindDay"
                         placeholder="多少天" :min="0" :step-strictly="true" :controls="false"/>
        天提醒报备人
      </el-form-item>
      <el-form-item prop="roleReportList" label="报备数量限制">
        <new-table :columns="columns" :data="model.roleReportList"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="save" icon="iconfont icon-Save">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RuleApi from "@/apis/rule"
import OrgApi from "@/apis/org"
import NewTable from "@/components/new-table"

export default {
  name: "index.vue",
  components: {NewTable},
  data() {
    const validator = (rule, value, callback) => {
      if (this.model[rule.rely] && !value) callback(rule.message)
      callback();
    };
    return {
      model: {
        collectionCount: 0,//领取数量
        enableCollectionRule: 0,//领取频率是否限制
        remindDay: 0, // 提前多少天提醒负责人
        enableRemindRule: 0, //是否提醒
        enableTakeBackRule: 0, //是否回收
        followupRule: false,// 是否勾选超过x天无跟进记录
        followupDay: 0,//超过x天无跟进记录
        noDealRule: false,// 是否勾选超过X天无成交
        noDealDay: 0,// 超过X天无成交
        shieldRule: false,// 是否勾选对原负责人屏蔽X天
        shieldDay: 0,// 对原负责人屏蔽X天
        conllectionDistance: '', // 手机端允许领取距离
        reportValidityDay: 0,//报备有效期
        serveProtectDay:0,// 服务保护期
        reportRemindDay: 0,//报备提前多少天到期提醒
        roleReportList: [],//角色报备数量列表

      },
      rules: {
        collectionCount: [
          {required: true, message: "请输入每天最多领取客户数量", trigger: 'change'}
        ],
        remindDay: [
          {required: true, message: "请输入提醒天数", trigger: 'change'}
        ],
        enableTakeBackRule: [
          {
            message: "请至少选择一项自动回收配置", trigger: 'blur', validator: (rule, value, callback) => {
              const {followupRule, noDealRule, shieldRule} = this.model
              if (value && !followupRule && !noDealRule && !shieldRule) callback(rule.message)
              callback()
            }
          }
        ],
        followupDay: [
          {message: "请输入超时天数", rely: "followupRule", trigger: 'change', validator}
        ],
        noDealDay: [
          {message: "请输入超时天数", rely: "noDealRule", trigger: 'change', validator}
        ],
        shieldDay: [
          {message: "请输入对原负责人屏蔽天数", rely: "shieldRule", trigger: 'change', validator}
        ],
        conllectionDistance: [
          {
            trigger: 'change', validator: (rule, value, callback) => {
              if (!value) {
                callback('请填写允许领取距离')
              } else if (isNaN(value) || value < 0) {
                callback('领取距离只能为大于0的数字')
              }
              callback()
            }
          }
        ],
        reportValidityDay: [
          {message: "请输入有效期", trigger: 'change', required: true}
        ],
        serveProtectDay: [
          {message: "请输入服务保护期", trigger: 'change', required: true}
        ],
        reportRemindDay: [
          {message: "请输入报备到期提醒天数", trigger: 'change', required: true}
        ],
        roleReportList: [
          {
            trigger: 'change', validator: (rule, value, callback) => {
              if (value.some(item => item.reportNum === undefined)) callback("请填写报备数量")
              callback()
            }
          }
        ]
      },
      columns: [
        {label: '角色', prop: "roleName", width: 200},
        {
          label: '最大报备数量', width: 300, render: (h, {row}) => {
            return <span>
             <el-input-number v-model={row.reportNum} min={0} step-strictly={true} controls={false} /> 个
            </span>
          }
        },
      ]
    }
  },
  created() {
    this.getRole()
  },
  methods: {
    async getRole() {
      const res = await OrgApi.getCompRoleList();
      this.model.roleReportList = (res||[]).map(role => {
        return {
          roleId: role.id,
          roleName: role.roleName,
          reportNum: 0
        }
      })
      this.getRuleInfo()
    },
    async getRuleInfo() {
      const rules = await RuleApi.getSysSettingInfo();
      if (!rules) return
      Object.assign(this.model, rules, {
        followupRule: !!rules.followupRule,
        noDealRule: !!rules.noDealRule,
        shieldRule: !!rules.shieldRule,
        roleReportList:this.model.roleReportList.map(item=>{
          const ruleItem=rules.roleReportList.find(roleItem=>roleItem.roleId===item.roleId)
          return {
            ...item,
            reportNum:ruleItem&&ruleItem.reportNum||0
          }
        })
      })
    },
    async save() {
      try {
        await this.$refs.form.validate()
        const _data = {
          ...this.model, ...{
            followupRule: Number(this.model.followupRule),
            noDealRule: Number(this.model.noDealRule),
            shieldRule: Number(this.model.shieldRule)
          }
        }
        if (!_data.enableCollectionRule) _data.collectionCount = 0;
        if (!_data.enableRemindRule) _data.remindDay = 0;
        if (!_data.enableTakeBackRule) {
          _data.followupDay = 0;
          _data.noDealDay = 0;
          _data.shieldDay = 0;
        } else {
          !this.model.followupRule && (_data.followupDay = 0)
          !this.model.noDealRule && (_data.noDealDay = 0)
          !this.model.shieldRule && (_data.shieldDay = 0)
        }
        const res = await RuleApi.saveSysSetting(_data)
        this.$message.success("保存成功")

      } catch (e) {
        console.error(e);
      }
    },
    changeBackRule() {
      this.$refs.form.clearValidate();
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/global";

.rule-setting {
  overflow: auto!important;
  .class-title {
    font-size: 16px;
    margin-bottom: 10px;
    align-items: center;

    i {
      width: 2px;
      height: 16px;
      background: $color-primary;
      margin-right: 5px;
      border-radius: 4px;
      overflow: hidden;
    }
  }

  .el-radio-group {
    background-color: #fff;
  }
}
</style>
